// extracted by mini-css-extract-plugin
module.exports = {"single-video":"SingleVideo_single-video__31erE","video-player":"SingleVideo_video-player__3R9hs","right-sidebar":"SingleVideo_right-sidebar__lY7Lu"};